import Step4Module2 from './Module2';

export default Step4Module2;
